export abstract class PositionStrategy {
  abstract getPosition(
    clientRect: ClientRect,
    windowRef: Window
  ): PositionStrategyResult;

  protected getWindowDimensions(windowRef: Window): ElementDimensions {
    return {
      height: windowRef.innerHeight,
      width: windowRef.innerWidth
    };
  }
}

export interface PositionStrategyResult {
  coords: PositionCoords;
  position: PositionOption;
}

export interface PositionCoords {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

export interface ElementDimensions {
  height: number;
  width: number;
}

export type PositionOption =
  | "top"
  | "bottom"
  | "left"
  | "right"
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "center"
  | "dead-center";
